// Copyright (c) 2017 Deere & Company

import {
    isNotEmpty,
    isNotNull
} from '../../../claim/shared/services/claim-shared-helper';
import {hasAccess} from '../../../shared/services/security';

export const isValid = (registration, product, security) => [
    isNotNull(registration.deliveryDate),
    isNotEmpty(registration.endUseCode.key),
    product.otherUnitRequired === 'Y' ? (isNotEmpty(registration.otherUseAmount.unit.key) && isNotNull(registration.otherUseAmount.amount) && isNotEmpty(registration.otherUseAmount.amount)) : true,
    isNotEmpty(registration.product.pin),
    isNotEmpty(registration.purchaserType.key),
    isNotEmpty(registration.statusIndicator.key) && !(registration.statusIndicator.key === 'NEW' && product.customerSummary.id),
    hasAccess(security, 'PRT', 'PRT_REGISTER_INTERNAL') ? true : isNotEmpty(registration.responsibleDealer.account),
    product.otherUnitRequired === 'N' ? (isNotEmpty(registration.useAmount.unit.key) && isNotNull(registration.useAmount.amount) && isNotEmpty(registration.useAmount.amount)) : true
].every(rule => rule);



// WEBPACK FOOTER //
// ./src/product/product-registration/services/validations.js